(() => {
  if (window.__lazyVideoGridInit) return;
  window.__lazyVideoGridInit = true;

  function setup(selector) {
    const videos = document.querySelectorAll(selector);
    if (!videos.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            if (video.preload !== 'auto') video.preload = 'auto';
            const playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    videos.forEach((video) => observer.observe(video));
  }

  function init() {
    setup('video.media-grid__media');
    setup('video.instagram-grid__media');
    setup('video.objection-carousel__media');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
